import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {DirectionsBtn, DirectionsBtnConfig} from "./directions_btn";

export const directionsBtnLoader = function (options = {}) {
    componentLoader(componentConfig(DirectionsBtn, DirectionsBtnConfig.componentTypeKey, DirectionsBtnConfig.baseHtmlClass), options);
};
